module.exports = {"buttons":{"cancel":"Cancelar conta","back":"Voltar"},"labels":{"dontWantService":"Não tenho mais interesse pelo serviço.","dontWantCar":"Não quero mais ter carro.","moving":"Estou me mudando.","changingCompanies":"Estou trocando de empresa.","cantPayForService":"Não posso mais pagar o serviço.","other":"Outro motivo:"},"placeholders":{"other":"Estou desempregado."},"errorMessage":{"otherMotive":"Não esqueça de dizer o motivo do cancelamento."}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/CancelAccountForm/data.json
// module id = 1770
// module chunks = 0